<template>
  <div id="modalTaxa" class="modal-zonas" v-show="opened">
    <div class="modal-zonas-content">
      <div class="py-4 py-md-3 bg-white shadow-sm">
        <div class="container text-center position-relative">
          <a href="javascript:" @click="closeModal" class="btn btn-outline-light position-absolute" style="left: 12px; top: -7px; border-radius: 50%" aria-label="Voltar">
            <i class="fa fa-chevron-left text-dark"></i>
          </a>
          <h1 class="h6 font-weight-bold m-auto">Áreas de Entrega</h1>
        </div>
      </div>
      <div class="container-fluid mt-3 mb-4">
        <input type="search" class="form-control mb-3" id="termZona" v-model="term" @keyup="pesquisarZonas" placeholder="Pesquisar"
               @keyup.down="$helpers.focusrElement('zona0')">
        <div>
          <div class="alert alert-warning d-flex align-items-center">
            <i class="fa fa-warning mr-2"></i>
            <div class="small">Selecione corretamente sua área de entrega ou seu pedido poderá ser cancelado.</div>
          </div>
          <a href="javascript:" tabindex="0" class="card card-zona text-dark"
             v-for="(z, index) in search" :id="`zona${index}`" @click="selecionarZona(z)"
             @keyup.enter.prevent="selecionarZona(z)"
             @keyup.down="$helpers.focusrElement('zona' + (index + 1))"
             @keyup.up="index > 0 ? $helpers.focusrElement('zona' + (index - 1)) : $helpers.focusrElement('termZona')">
            <div class="zona-item">
              <icon name="address" class="text-primary mr-2" size="18"></icon>
              <div>
                <b>{{z.nome_zona}}</b>
                <div class="small" v-if="z.tempo_entrega > 40">
                  {{z.tempo_entrega | tempo}}
                </div>
              </div>
              <i class="fa fa-angle-right text-primary ml-auto"></i>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CardInfo from './CardInfo'
  import Loading from "./Loading";
  import Icon from "./Icon";
  import ModalMenu from "./ModalMenu";

  export default {
    name: "ZonasEntregas",
    components: {ModalMenu, Icon, Loading, CardInfo},
    props: ['sacola'],
    data() {
      return {
        token: localStorage.getItem('token'),
        opened: false,
        avancar: false,
        term: '',
        search: [],
        dados: {}
      }
    },

    methods: {
      closeModal() {
        document.body.classList.remove("modal-open");
        this.opened = false;
      },

      abrirModal(avancar) {
        document.body.classList.add("modal-open");
        this.avancar = !!avancar;
        this.search = this.zonas;
        this.term = '';
        this.opened = true;

        this.$nextTick(() => {
          this.$helpers.focusrElement('termZona');
        })
      },

      selecionarZona(zona) {
        this.$emit('addZona', zona, this.avancar);
        this.closeModal();
      },

      pesquisarZonas() {
        if (this.term.trim().length) {
          this.search = this.zonas.filter(z => z.texto.includes(this.term.toLowerCase()) || z.nome_zona.toLowerCase().includes(this.term.toLowerCase()));

        } else {
          this.search = this.zonas;
        }
      },
    },

    computed: {
      zonas() {
        return this.$store.state.empresa.zonas
      }
    },
  }
</script>

<style scoped>
  .modal-zonas {
    display: block;
    position: fixed; /* Stay in place */
    z-index: 1040; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }

  .modal-zonas-content {
    background-color: #fefefe;
    overflow: auto;
    margin: 48px auto;
    width: 500px;
    height: 75vh;
    position: relative;
    border-radius: 12px;
  }

  .card-zona {
    margin-bottom: 8px;
  }

  .zona-item {
    display: flex;
    align-items: center;
    min-height: 71px;
    padding: 14px;
  }

  .card-zona:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 600px) {
    .modal-zonas-content {
      overflow: auto;
      min-height: 100%;
      height: 100vh;
      width: 100%;
      margin: 0;
      border-radius: 0;
    }
  }
</style>
